export default __webpack_public_path__ + "static/media/pills.97912182.svg";